var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FAS_CIRCLE_EXCLAMATION } from '../../../const/iconProps';
import { AlertsBodyErrorWrapper, CustomMessageBox } from './subcomponents';
var ErrorBanner = function (_a) {
    var children = _a.children;
    return (_jsx(AlertsBodyErrorWrapper, __assign({ "data-test": "AlertsBodyErrorWrapper" }, { children: _jsx(CustomMessageBox, __assign({ "data-test": "CustomMessageBox", type: "error", icon: _jsx(FontAwesomeIcon, { icon: FAS_CIRCLE_EXCLAMATION, size: "sm" }) }, { children: _jsx("div", __assign({ "data-test": "error-content" }, { children: children })) })) })));
};
export default ErrorBanner;
